import shlumberger from './shlumberger/store/index.js';
import batChampionship from './bat-championship/store/index.js';
import batPersonalAccount from './bat-personal-account/store/index.js';
import questionnaireLanding from './questionnaire-landing/store/index.js';
import citibank from './citibank/store/index.js';
import deloitteSF from './deloitte-sf/store/index.js';
import unilever from './unilever/store/index.js';
import sportmaster from './sportmaster/store/index.js';
import alrosa from './alrosa/store';
import japan517 from './japan-517/store';
import feniche from './feniche/store';
import mars from './mars/store';
import kpmg from './kpmg/store';

const state = {
  activeProcessName: null,

  // впервые понадобился для Спормастера чтобы добавлять условие использования спецпроцесса даже при условии смешанных вакансий
  // определяется в _helpers/security.js при запросе инфо о пользователи (data.company.meta.active_process)
  companyCommonSpecialProcess: ''
};

const getters = {
  /**
   * @TODO remove using of getters['user/activeProcess'] when it will be removed from backend (for now used for compatebility)
   */
  getName(state, getters, rootState, rootGetters) {
    return state.activeProcessName || rootGetters['user/activeProcess'];
  },

  // Better name for one of the global and most used variable in project (spec processes), it duplicates getName() yet :'(
  getProcessName(state, rootGetters) {
    if (state.activeProcessName !== undefined || rootGetters['user/activeProcess'] !== undefined) {
      return state.activeProcessName || rootGetters['user/activeProcess'];
    } else {
      return '';
    }
  }
};

const mutations = {
  setName(state, name) {
    state.activeProcessName = name;
  },

  // TODO: выпилить так как сделал при логине запись спецпроцесса
  SET_COMPANY_COMMON_SPECIAL_PROCESS: (state, val) => {
    state.companyCommonSpecialProcess = val;
  }
};

const actions = {
  setName({ commit }, name) {
    commit('setName', name);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    shlumberger,
    batChampionship,
    batPersonalAccount,
    questionnaireLanding,
    citibank,
    deloitteSF,
    unilever,
    sportmaster,
    japan517,
    alrosa,
    feniche,
    mars,
    kpmg
  }
};
